import { FileText, User, Clock, FileCheck, Globe, Monitor, FileType, Star, Users, Target, Calendar } from "lucide-react"
import { Input } from "../ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { Textarea } from "../ui/textarea"
import { Badge } from "../ui/badge"
import BaseSelectInfoFormItems from "./base_select_info_form_items"


const BaseInfoBlock2 = ({
    onValuesChange = () => {},
    fieldConfigs = [
        {
            name: "post_category",
            label: "發布形式分類", 
            label_icon: "<Globe />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇發布形式儲存資料夾...", 
            badge: true, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "社群媒體",
                    name: "社群媒體",
                    description: "社群媒體",
                    value: 1,
                    id: 1,
                },
                {
                    label: "線上",
                    name: "線上",
                    description: "線上",
                    value: 2,
                    id: 2,
                },
                {
                    label: "線下",
                    name: "線下",
                    description: "線下",
                    value: 3,
                    id: 3,
                },
                {
                    label: "混合",
                    name: "混合",
                    description: "混合",
                    value: 4,
                    id: 4,
                },
            ], 
            order: 0, 
            disabled: false, 
            hidden: false,
        },
        {
            name: "post_type",
            label: "發布形式", 
            label_icon: "<Monitor />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇發布形式...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "Facebook",
                    name: "Facebook",
                    description: "Facebook",
                    value: 1,
                    id: 1,
                },
                {
                    label: "網站",
                    name: "網站",
                    description: "網站",
                    value: 2,
                    id: 2,
                },
                {
                    label: "社群媒體",
                    name: "社群媒體",
                    description: "社群媒體",
                    value: 3,
                    id: 3,
                },
                {
                    label: "電子郵件",
                    name: "電子郵件",
                    description: "電子郵件",
                    value: 4,
                    id: 4,
                },
            ], 
            order: 1, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "subject",
            label: "主題項目", 
            label_icon: "<FileType />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇分類", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "產品介紹/推廣文",
                    name: "產品介紹/推廣文",
                    description: "產品介紹/推廣文",
                    value: 1,
                    id: 1,
                },
                {
                    label: "促銷活動",
                    name: "促銷活動",
                    description: "促銷活動",
                    value: 2,
                    id: 2,
                },
                {
                    label: "季節性活動",
                    name: "季節性活動",
                    description: "季節性活動",
                    value: 3,
                    id: 3,
                },
                {
                    label: "節慶活動",
                    name: "節慶活動",
                    description: "節慶活動",
                    value: 4,
                    id: 4,
                },
            ], 
            order: 2, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "version",
            label: "版本", 
            label_icon: "<Star />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇版本...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "精簡版",
                    name: "精簡版",
                    description: "精簡版",
                    value: 1,
                    id: 1,
                },
                {
                    label: "複雜版",
                    name: "複雜版",
                    description: "複雜版",
                    value: 2,
                    id: 2,
                },
                {
                    label: "完成版",
                    name: "完成版",
                    description: "完成版",
                    value: 3,
                    id: 3,
                },
            ],  
            order: 3, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "specific_category",
            label: "專用產業別", 
            label_icon: "<User />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇產業別...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "快節奏消費型",
                    name: "快節奏消費型",
                    description: "快節奏消費型",
                    value: 1,
                    id: 1,
                },
                {
                    label: "零售業",
                    name: "零售業",
                    description: "零售業",
                    value: 2,
                    id: 2,
                },
                {
                    label: "科技業",
                    name: "科技業",
                    description: "科技業",
                    value: 3,
                    id: 3,
                },
                {
                    label: "金融業",
                    name: "金融業",
                    description: "金融業",
                    value: 4,
                    id: 4,
                },
            ],  
            order: 4, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "content_specialties",
            label: "產業內容特性", 
            label_icon: "<Target />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇內容特性...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "需要快、商品更新頻繁、行銷活動多、使用者注意力短暫",
                    name: "需要快、商品更新頻繁、行銷活動多、使用者注意力短暫",
                    description: "需要快、商品更新頻繁、行銷活動多、使用者注意力短暫",
                    value: 1,
                    id: 1,
                },
                {
                    label: "技術型",
                    name: "技術型",
                    description: "技術型",
                    value: 2,
                    id: 2,
                },
                {
                    label: "創意型",
                    name: "創意型",
                    description: "創意型",
                    value: 3,
                    id: 3,
                },
                {
                    label: "資訊型",
                    name: "資訊型",
                    description: "資訊型",
                    value: 4,
                    id: 4,
                },
            ],  
            order: 5, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "actual_application",
            label: "具體應用場景", 
            label_icon: "<Calendar />", 
            label_css: "block text-sm font-medium text-gray-700", 
            component: <></>, 
            component_type: "MULTISELECT", 
            placeholder: "選擇應用場景...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "美妝保養、飲品零食、直播電商、快時尚服飾",
                    name: "美妝保養、飲品零食、直播電商、快時尚服飾",
                    description: "美妝保養、飲品零食、直播電商、快時尚服飾",
                    value: 1,
                    id: 1,
                },
                {
                    label: "電子商務",
                    name: "電子商務",
                    description: "電子商務",
                    value: 2,
                    id: 2,
                },
                {
                    label: "社群行銷",
                    name: "社群行銷",
                    description: "社群行銷",
                    value: 3,
                    id: 3,
                },
                {
                    label: "實體活動",
                    name: "實體活動",
                    description: "實體活動",
                    value: 4,
                    id: 4,
                },
            ],  
            order: 6, 
            disabled: false, 
            hidden: false, 
        },
    ], 
    columnCount = 3, 
    fieldValues = {},
    formSubmitCheck = false,
    onFinish = () => {},
}) => {
    return (
        <BaseSelectInfoFormItems 

            onValuesChange={(values) => {
                onValuesChange(values)
            }}
            columnCount={columnCount}
            wrapperCol={24}
            fill={true}
            gutter={[16,24]} 
            onFinish={(values) => {
                // console.log({values})
                onFinish(values)
            }}
            fieldConfigs={fieldConfigs}
            fieldValues={fieldValues}
            formSubmitCheck={formSubmitCheck}
        />
    )
}

export default BaseInfoBlock2;